import { Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'

import YouTubeNodeView from './YouTubeNodeView'

/**
 * YouTube 视频节点扩展
 * 允许在编辑器中插入和编辑 YouTube 视频
 */
export const YouTube = Node.create({
  name: 'youtube',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (element) => element.getAttribute('src'),
        renderHTML: (attributes) => {
          if (!attributes.src) {
            return {}
          }
          return {
            src: attributes.src,
          }
        },
      },
      width: {
        default: 640,
        parseHTML: (element) => element.getAttribute('width') || 640,
        renderHTML: (attributes) => {
          if (!attributes.width) {
            return {}
          }
          return {
            width: attributes.width,
          }
        },
      },
      height: {
        default: 360,
        parseHTML: (element) => element.getAttribute('height') || 360,
        renderHTML: (attributes) => {
          if (!attributes.height) {
            return {}
          }
          return {
            height: attributes.height,
          }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        // 匹配所有可能的 YouTube iframe 标签
        tag: 'iframe',
        getAttrs: (element) => {
          if (typeof element === 'string') {
            return false
          }
          const src = element.getAttribute('src')
          if (!src) {
            return false
          }

          // 匹配各种 YouTube URL 格式的正则表达式
          // 支持: youtube.com, youtu.be, youtube-nocookie.com
          // 支持: www, m, music, gaming 等子域名
          // 支持: /watch, /embed, /v/ 等路径
          const youtubeRegex =
            /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:music\.)?(?:gaming\.)?(?:youtube\.com|youtu\.be|youtube-nocookie\.com)\/(?:watch\?v=|embed\/|v\/|shorts\/|live\/|)([a-zA-Z0-9_-]{11})/i

          if (youtubeRegex.test(src)) {
            return {
              src,
              width: element.getAttribute('width') || 640,
              height: element.getAttribute('height') || 360,
            }
          }
          return false
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['iframe', HTMLAttributes]
  },

  addNodeView() {
    return ReactNodeViewRenderer(YouTubeNodeView)
  },

  addCommands() {
    return {
      setYoutubeVideo:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          })
        },
    }
  },
})
